import KunLoading65 from './src/index'

KunLoading65.install = function (Vue) {
	Vue.component(KunLoading65.name, KunLoading65);
}

export default KunLoading65;
